import { ArrowLeft } from 'lucide-react'
import { Link } from 'react-router-dom'
import { Brand } from '../components/Brand'

export default function NotFoundPage() {
  return <div className="not-found"><Brand /><span>404</span><h1>Essa luta não está no card.</h1><p>A página pode ter mudado ou o convite expirou.</p><Link to="/" className="button button--primary"><ArrowLeft size={18} /> Voltar ao início</Link></div>
}
